import {TGetUnreadCountResponse} from '@/_api/notifications/notifications.api';

export default class NotificationsHelper {

  public static prepareBadgeNotificationNumber(count: number): string {
    // limit is 99
    return count <= 99 ? ('' + count) : ('99+');
  }

  public static responseToNotificationCountConverter(responseObj: any): TGetUnreadCountResponse {
    if(!responseObj) return null;
    return Object.assign({}, responseObj);
  }

}
